import { Box, Grid, Typography } from '@mui/material';
import { theme } from '@shared/theme';
import ReviewRating from '../../review/components/ReviewRating';

const RatingsReader: React.FC<{
  ratings: { label: string; answer: string | number | null }[];
}> = ({ ratings }) => {
  const labelMap: { [key: string]: string } = {
    transparency: 'Transparency',
    clarity: 'Clarity of Needs',
    understanding: 'Technical Competence',
    responsiveness: 'Responsiveness',
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 'bold',
          color: '#0b74da',
          paddingBottom: theme.spacing(1.5),
          borderBottom: '2px solid #e5e9ee',
          margin: `${theme.spacing(2)} 0`,
        }}
      >
        Review Ratings
      </Typography>
      <Grid container spacing={2}>
        {ratings.map((rating, index) => (
          <Grid size={{ xs: 12, md: 6 }} key={index}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
                background: '#f8f9fa',
                width: '100%',
                borderRadius: theme.spacing(1),
                marginBottom: theme.spacing(1.5),
                transition: 'all 0.3s ease-in-out',
                whiteSpace: 'nowrap',
                '&:hover': {
                  background: '#eef2f7',
                  transform: 'scale(1.02)',
                },
                [theme.breakpoints.down('md')]: {
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  width: '100%',
                  padding: theme.spacing(1.5),
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  flex: 1,
                  whiteSpace: 'nowrap',
                  textAlign: 'left',
                  marginRight: theme.spacing(1),
                  [theme.breakpoints.down('md')]: {
                    fontSize: 15,
                  },
                }}
              >
                {labelMap[rating.label.toLowerCase()]}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flex: 1,
                }}
              >
                <ReviewRating value={String(rating.answer)} isReadOnly={true} label="" name="" />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default RatingsReader;
